import { Input, InputProps } from 'antd';
import { memo, useEffect, useState } from 'react';
import { uiStore } from 'stores/root_store';

interface CustomInputProps extends InputProps {}

function CustomInputString(props: CustomInputProps) {
  let size = '';
  switch (props.size) {
    case 'small':
      size = `!py-0.6 `;
      break;
    default:
      size = '';
  }
  return (
    <Input
      {...props}
      className={
        uiStore.theme.name +
        ' text-default !rounded-sm hover:!border-primary focus:!border-primary focus:!shadow-none disabled:!border-[#d9d9d9] disabled:cursor-not-allowed ' +
        size +
        props.className
      }
    />
  );
}

export default memo(CustomInputString);
